// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o4KhQ","type":"styles_type__SqLN2","choices":"styles_choices__23iNB"};